var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection2Light(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 300",
    width: 960,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 300,
    fill: "#B0ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 94L32 88.8C64 83.7 128 73.3 192 63.8C256 54.3 320 45.7 384 50.8C448 56 512 75 576 84.3C640 93.7 704 93.3 768 86.5C832 79.7 896 66.3 928 59.7L960 53L960 0L928 0C896 0 832 0 768 0C704 0 640 0 576 0C512 0 448 0 384 0C320 0 256 0 192 0C128 0 64 0 32 0L0 0Z",
    fill: "#DDF7FF",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2Light);
export default __webpack_public_path__ + "static/media/section2Light.8b029326273b1e4596a8210f50e19732.svg";
export { ForwardRef as ReactComponent };